import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import AssessmentIcon from '@mui/icons-material/Assessment';

export default function GenerateReportButton({
  selectedGoals,
  isGenerating,
  onGenerateReport,
}) {
  // const isDisabled = selectedGoals?.length === 0 || isGenerating;
  const isDisabled = true;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button
        variant='contained'
        size="large"
        disabled={isDisabled}
        onClick={onGenerateReport}
        startIcon={
          isGenerating ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            <AssessmentIcon />
          )
        }
        sx={{
          bgcolor: 'var(--clr-theme-purple)',
          '&:hover': {
            bgcolor: 'var(--clr-theme-purple-hover)',
          },
          '&:disabled': {
            bgcolor: '#e0e0e0',
            color: '#9e9e9e',
            cursor: 'not-allowed',
          },
          px: 4,
          py: 1.5,
          textTransform: 'none',
          fontSize: '1.1rem',
          fontWeight: 'medium',
        }}
      >
        {isGenerating ? 'Generating Report...' : 'Coming Soon Generate Progress Report'}
      </Button>
    </Box>
  );
} 